import { render, staticRenderFns } from "./TkHeaderAccordion.vue?vue&type=template&id=695ddf0a&"
import script from "./TkHeaderAccordion.vue?vue&type=script&lang=js&"
export * from "./TkHeaderAccordion.vue?vue&type=script&lang=js&"
import style0 from "./TkHeaderAccordion.vue?vue&type=style&index=0&id=695ddf0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports